module.exports={
  "name": "cucumber",
  "description": "The official JavaScript implementation of Cucumber.",
  "keywords": [
    "testing",
    "bdd",
    "cucumber",
    "gherkin",
    "tests"
  ],
  "version": "1.3.0",
  "homepage": "http://github.com/cucumber/cucumber-js",
  "author": "Julien Biezemans <jb@jbpros.com> (http://jbpros.net)",
  "contributors": [
    "Julien Biezemans <jb@jbpros.com> (http://jbpros.net)",
    "Fernando Acorreia <fernandoacorreia@gmail.com>",
    "Paul Jensen <paulbjensen@gmail.com>",
    "Kushal Pisavadia",
    "Olivier Melcher <olivier.melcher@gmail.com>",
    "Tristan Dunn <tristanzdunn@gmail.com>",
    "Ted de Koning",
    "Renier Morales <renier@morales-rodriguez.net>",
    "Aslak Hellesøy <aslak.hellesoy@gmail.com>",
    "Aaron Garvey",
    "Omar Gonzalez <omar@almerblank.com>",
    "Chris Young <chris@chrisyoung.org>",
    "Israel Halle <isra017@gmail.com>",
    "Matteo Collina <matteo.collina@gmail.com>",
    "Niklas Närhinen <niklas@narhinen.net>",
    "Kim, Jang-hwan <janghwan@gmail.com>",
    "Michael Zedeler <michael@zedeler.dk>",
    "Tom V <tom@toc.com>",
    "David Godfrey <reactiveraven@reactiveraven.co.uk>",
    "Paul Shannon (http://devpaul.com)",
    "Simon Dean <simon@simondean.org> (http://www.simondean.org)",
    "John Wright <johngeorge.wright@gmail.com>",
    "Johny Jose <johny@playlyfe.com>",
    "Marat Dyatko <vectart@gmail.com>",
    "Tim Perry <tim.perry@softwire.com>",
    "Fedotov Daniil <hairyhum@gmail.com>",
    "unknown <jharlin@NormanDev2.telogical.com>",
    "Ben Van Treese <vantreeseba@gmail.com>",
    "Gabe Hayes <gabriel.hayes@gmail.com>",
    "Brian Clozel <brian.clozel@gmail.com>",
    "Lukas Degener <l.degener@tarent.de>",
    "Simon Lampen <simonlampen@vinsight.net>",
    "Eddie Loeffen <eddieloeffen@gmail.com>",
    "Stanley Shyiko <stanley.shyiko@gmail.com>",
    "Artur Kania <kaniartur@gmail.com>",
    "Sam Saccone <sam@samx.it>",
    "Craig Morris <craig.michael.morris@gmail.com>",
    "Gary Taylor <gary.taylor@hismessages.com>",
    "Krispin Schulz <krispin.schulz@blackbridge.com>",
    "Elwyn <elwyn@L1.co.nz>",
    "Jan-Eric Duden <jeduden@gmail.com>",
    "kostya.misura <kostya.misura@gmail.com>",
    "Julian <microweb10@gmail.com>",
    "nebehr <thorgeir@tut.by>",
    "Jesse Harlin <harlinjesse@gmail.com>",
    "Sonny Piers <sonny@fastmail.net>",
    "Will Farrell <will@mojotech.com>",
    "Kevin Kirsche <Kev.Kirsche+GitHub@gmail.com>",
    "chrismilleruk <chrismilleruk@gmail.com>",
    "Mateusz Derks <mateusz.derks@schibsted.pl>",
    "Mark Amery <markamery@btinternet.com>",
    "Artem Repko <roby-boby@ukr.net>",
    "zs-zs <zsolt.zsigmondi@hotmail.com>",
    "Dale Gardner <dalegardner@live.com>",
    "Charles Rudolph <charles.rudolph@originate.com>",
    "Karthik Viswanath <karthik.viswanath-contractor@adp.com>",
    "Marcel Hoyer <mhoyer@pixelplastic.de>",
    "Artem Bronitsky <quex@yandex.ru>",
    "Karine Pires <karine.pires@alterway.fr>",
    "Rick Lee-Morlang <rick@lee-morlang.com>",
    "Noah Davis <noahd1@yahoo.com>",
    "Miika Hänninen <miika.hanninen@gmail.com>",
    "Kevin Goslar <kevin.goslar@gmail.com>",
    "John Krull <astrom.flux@gmail.com>",
    "Maxim Koretskiy <mr.green.tv@gmail.com>",
    "seantdg <sm.davis@gmx.com>",
    "Marc Burton <marc.burton@first-utility.com>",
    "Jonathan Kim <jkimbo@gmail.com>",
    "Ádám Gólya <adam.golya@lab.coop>",
    "Scott Deakin <scott.deakin@kantar.com>",
    "efokschaner <eddyaod@gmail.com>",
    "John McLaughlin <john.mjhm@gmail.com>",
    "Josh Goldberg <joshuakgoldberg@outlook.com>",
    "Artur Pomadowski <artur.pomadowski@gmail.com>",
    "Benjamín Eidelman <beneidel+gh@gmail.com>",
    "Jan Molak <jan.molak@smartcodeltd.co.uk>",
    "dbillingham <dbillinghamuk@yahoo.co.uk>"
  ],
  "repository": {
    "type": "git",
    "url": "git://github.com/cucumber/cucumber-js.git"
  },
  "bugs": {
    "email": "cukes@googlegroups.com",
    "url": "http://github.com/cucumber/cucumber-js/issues"
  },
  "directories": {
    "lib": "./lib"
  },
  "main": "./lib/cucumber",
  "engines": {
    "node": ">=0.10"
  },
  "dependencies": {
    "camel-case": "^3.0.0",
    "cli-table": "^0.3.1",
    "co": "^4.6.0",
    "colors": "^1.1.2",
    "commander": "^2.9.0",
    "cucumber-html": "^0.2.3",
    "duration": "^0.2.0",
    "gherkin": "^4.0.0",
    "glob": "^7.0.0",
    "is-generator": "^1.0.2",
    "lodash": "^4.0.0",
    "stack-chain": "^1.3.5",
    "stacktrace-js": "^1.3.0"
  },
  "devDependencies": {
    "ansi_up": "^1.3.0",
    "async": "^1.5.0",
    "browserify": "^13.0.0",
    "coffee-script": "^1.10.0",
    "connect": "^3.4.0",
    "exorcist": "^0.4.0",
    "fs-extra": "^0.26.0",
    "jasmine": "^2.3.2",
    "jshint": "^2.9.1",
    "json-diff": "^0.3.1",
    "rimraf": "^2.4.3",
    "serve-static": "^1.10.0",
    "sinon": "^1.17.3",
    "tmp": "0.0.28"
  },
  "scripts": {
    "feature-test": "node ./bin/cucumber.js",
    "feature-test-es5": "node ./bin/cucumber.js -p es5",
    "lint": "jshint bin features lib scripts spec",
    "test": "npm run lint && npm run unit-test && npm run feature-test",
    "test-es5": "npm run lint && npm run unit-test && npm run feature-test-es5",
    "unit-test": "jasmine",
    "prebuild-release": "npm install",
    "build-release": "node ./scripts/release.js"
  },
  "bin": {
    "cucumber.js": "./bin/cucumber.js",
    "cucumber-js": "./bin/cucumber.js",
    "cucumberjs": "./bin/cucumber.js"
  },
  "license": "MIT",
  "files": [
    "bin/",
    "lib/",
    "release/"
  ]
}
